module.exports = __webpack_public_path__ + "src/modules/web-agent/assets/audio/end_chat.wav";